import styled, { css } from 'styled-components';

export default styled.div`
  ${({ $card }) => $card && css`
    margin: 0 auto;
    background-color: white;
    padding: 2rem;
    box-shadow: 0 0 11px 2px rgba(0, 0, 0, 0.11);
    border-radius: .25rem;
    border: solid 1px #dedede;
    max-width: 36.5rem;
  `}
`;
